export default "/images/become-host-2.jpeg?84ad5fceeaf2ba9f9e16bd772b9f8a2b";